"use client"
import React from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";

import "@/components/shared/AlertInstance.css";

const AlertInstance = ({
  show,
  heading,
  textContent,
  footerContent,
  onClose,
  footerClassName
}) => {
  return (
    <Modal
      className="modal alert-instance"
      show={show}
      size="lg"
      aria-labelledby="contained-modal-title-vcenter"
      centered
      onHide={onClose}
    >
      <Modal.Header className="empty" closeButton></Modal.Header>
      <Modal.Body>
        <h3>{heading}</h3>
        <div>{textContent}</div>
      </Modal.Body>
      {footerContent && (
        <Modal.Footer className={footerClassName ?? ""}>
          <div>{footerContent}</div>
        </Modal.Footer>
      )}
    </Modal>
  );
};
export default AlertInstance;
